import i18n from 'i18n'

export const resetPasswordTranslations = (): Record<any, any> => {
  return {
    translation: {
      loading: i18n.t('shared.reset_password.loading'),
      new_password: i18n.t('shared.reset_password.new_password'),
      backButton: i18n.t('shared.reset_password.backButton'),
      resetSuccessful: i18n.t('shared.reset_password.resetSuccessful'),
      resetSuccessfulMsg: i18n.t('shared.reset_password.resetSuccessfulMsg'),
      resetFail: i18n.t('shared.reset_password.resetFail'),
      resetFailMsg: i18n.t('shared.reset_password.resetFailMsg'),
      resetPasswordButton: i18n.t('shared.reset_password.resetPasswordButton'),
      resetPasswordRequirements: i18n.t('shared.reset_password.resetPasswordRequirements'),
      invalidactioncode: i18n.t('shared.reset_password.invalidactioncode'),
      expiredactioncode: i18n.t('shared.reset_password.expiredactioncode'),
      email: i18n.t('shared.reset_password.email'),
      emailResetSuccessfulMsg: i18n.t('shared.reset_password.emailResetSuccessfulMsg'),
    },
  }
}
